var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pivot-color-settings-panel" },
    [
      _c(
        "a-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("a-tab-pane", { key: "heatmap", attrs: { tab: "Heat Map" } }, [
            _c(
              "div",
              { staticClass: "settings-section" },
              [
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-checkbox",
                      {
                        attrs: { checked: _vm.settings.heatMap.enabled },
                        on: { change: _vm.onHeatMapEnabledChange },
                      },
                      [
                        _vm._v(
                          "\n                        Heat Map'i Aktif Et\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.settings.heatMap.enabled
                  ? [
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-checkbox",
                            {
                              attrs: {
                                checked:
                                  _vm.settings.heatMap.ignoreZero !== false,
                              },
                              on: { change: _vm.onIgnoreZeroChange },
                            },
                            [
                              _vm._v(
                                "\n                            0 ve Boş Değerleri Renklendirme\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Renk Skalası" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { value: _vm.settings.heatMap.scale },
                              on: { change: _vm.onScaleChange },
                            },
                            _vm._l(_vm.colorScales, function (scale, key) {
                              return _c(
                                "a-select-option",
                                { key: key, attrs: { value: key } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(scale.name) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "color-preview" }, [
                        _c("div", { staticClass: "preview-label" }, [
                          _vm._v("Renk Önizleme:"),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "gradient-bar",
                          style: _vm.gradientStyle,
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "gradient-labels" }, [
                          _c("span", [_vm._v("Min")]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Max")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("a-divider", [_vm._v("veya Özel Renkler")]),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Minimum Değer Rengi" } },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80px" },
                            attrs: {
                              value: _vm.settings.heatMap.minColor,
                              type: "color",
                            },
                            on: { change: _vm.onMinColorChange },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: "Maximum Değer Rengi" } },
                        [
                          _c("a-input", {
                            staticStyle: { width: "80px" },
                            attrs: {
                              value: _vm.settings.heatMap.maxColor,
                              type: "color",
                            },
                            on: { change: _vm.onMaxColorChange },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "manual", attrs: { tab: "Manuel Kurallar" } },
            [
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c(
                    "div",
                    { staticClass: "rules-list" },
                    _vm._l(_vm.settings.manualRules, function (rule, index) {
                      return _c(
                        "div",
                        { key: "rule-" + index, staticClass: "rule-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "rule-header" },
                            [
                              _c("span", { staticClass: "rule-index" }, [
                                _vm._v("Kural " + _vm._s(index + 1)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "link", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeRule(index)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("delete"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "rule-config" },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "Koşul" } },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100px" },
                                      attrs: { value: rule.condition.operator },
                                      on: {
                                        change: function (val) {
                                          return _vm.onOperatorChange(
                                            index,
                                            val
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: ">" } },
                                        [_vm._v(">")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: ">=" } },
                                        [_vm._v(">=")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "<" } },
                                        [_vm._v("<")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "<=" } },
                                        [_vm._v("<=")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "=" } },
                                        [_vm._v("=")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "!=" } },
                                        [_vm._v("!=")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "between" } },
                                        [_vm._v("Arasında")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              rule.condition.operator !== "between"
                                ? _c(
                                    "a-form-item",
                                    { attrs: { label: "Değer" } },
                                    [
                                      _c("a-input-number", {
                                        staticStyle: { width: "100%" },
                                        attrs: { value: rule.condition.value },
                                        on: {
                                          change: function (val) {
                                            return _vm.onConditionValueChange(
                                              index,
                                              val
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : [
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Min Değer" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            value: rule.condition.minValue,
                                          },
                                          on: {
                                            change: function (val) {
                                              return _vm.onConditionMinValueChange(
                                                index,
                                                val
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "Max Değer" } },
                                      [
                                        _c("a-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            value: rule.condition.maxValue,
                                          },
                                          on: {
                                            change: function (val) {
                                              return _vm.onConditionMaxValueChange(
                                                index,
                                                val
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                { attrs: { label: "Renk" } },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "80px" },
                                    attrs: { value: rule.color, type: "color" },
                                    on: {
                                      change: function (e) {
                                        return _vm.onRuleColorChange(
                                          index,
                                          e.target.value
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "dashed", block: "" },
                      on: { click: _vm.addRule },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                      _vm._v(
                        "\n                    Yeni Kural Ekle\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }